export default __webpack_public_path__ + "static/media/Hair_4_M_C2.e4932149.svg";